import React from 'react';
import { Box } from 'grommet';
const PageWrapper = (props) => {
    const { children, vAlign = 'start', pad = 'medium', ...styles } = props;
    return (React.createElement(Box, { flex: true, fill: true, align: "center", justify: vAlign, pad: pad, overflow: "auto", ...styles }, children));
};
PageWrapper.displayName = 'PageWrapper';
export default PageWrapper;
